import React from 'react';
import CorePage from '../core/CorePage';
 

export default class DesktopOnly extends CorePage {
    constructor(props){
        super(props);
    }


    render(){
        return(
            <div className="desktoponly">
                <div><i class="material-icons">
                desktop_mac
                </i></div>

               <div>
               <b>{this.rb("desktop_only")}</b>
               </div>
            </div>
        );
    }


}


// WEBPACK FOOTER //
// ./src/views/warning/DesktopOnly.js